import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

const PricingSection = () => {
  const plans = [
    {
      name: "Starter",
      price: "₹50,000",
      period: "per month",
      features: [
        "Up to 50 screens",
        "Basic targeting",
        "Weekly reports",
        "Email support"
      ],
      buttonText: "Get Started",
      buttonStyle: "border-2 border-primary text-primary hover:bg-primary hover:text-white"
    },
    {
      name: "Professional",
      price: "₹1,50,000",
      period: "per month",
      features: [
        "Up to 200 screens",
        "Advanced targeting",
        "Real-time analytics",
        "Priority support",
        "A/B testing"
      ],
      buttonText: "Get Started",
      buttonStyle: "bg-white text-primary hover:bg-gray-100",
      popular: true
    },
    {
      name: "Enterprise",
      price: "Custom",
      period: "pricing",
      features: [
        "Unlimited screens",
        "Custom integrations",
        "Dedicated manager",
        "24/7 support"
      ],
      buttonText: "Contact Sales",
      buttonStyle: "border-2 border-primary text-primary hover:bg-primary hover:text-white"
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Transparent Pricing
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Choose the plan that fits your advertising goals
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`rounded-2xl shadow-card p-8 border border-border relative ${
                plan.popular ? 'bg-primary text-white border-2 border-primary' : 'bg-white'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-accent text-text-primary px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className={`text-xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-text-primary'}`}>
                  {plan.name}
                </h3>
                <div className={`text-4xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-text-primary'}`}>
                  {plan.price}
                </div>
                <div className={plan.popular ? 'opacity-90' : 'text-text-secondary'}>
                  {plan.period}
                </div>
              </div>
              
              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center space-x-3">
                    <CheckIcon className={`w-5 h-5 ${plan.popular ? 'text-white' : 'text-success'}`} />
                    <span className={plan.popular ? 'opacity-90' : 'text-text-secondary'}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
              
              <button className={`w-full font-semibold py-3 rounded-lg transition-all duration-250 ${plan.buttonStyle}`}>
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;